import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const StepWrapper = styled.div`
	position: relative;
	border-radius: 1px;
	padding: 12px 32px;
	border-width: 0 1px 1px 1px;
	border-color: ${colors.grey4};
	border-style: dashed;
	background-color: white;
	border-radius: 0 0 3px 3px;
	display: flex;
	flex-direction: column;
`;
